import { BaseService } from "services/_baseService";

class WarehousesAdminService extends BaseService<any> {
  constructor() {
    super(`warehouses`);
  }
}

export default new WarehousesAdminService();
